const getLsKey = (profileId) => `user:${profileId}:memorized-search`;

export const memorizeSearch = (tags, profileId) => {
  const key = getLsKey(profileId);
  localStorage.setItem(key, JSON.stringify(tags));
};

export const forgetSearch = (profileId) => {
  const key = getLsKey(profileId);
  localStorage.setItem(key, '');
};

export const getMemorizedSearch = (profileId) => {
  const key = getLsKey(profileId);
  const item = localStorage.getItem(key);
  return item ? JSON.parse(item) : null;
};
